document.addEventListener("DOMContentLoaded", () => {

    $(document).ready(() => {

        // const fillImages = (variant_title) => {
        // $(".Product__Media__Sidebar").removeClass("hidden");
        // $(".Product__Media__Main").removeClass("full");
        // let id = 0;
        // const filtered_media = media.filter(item => item[0] == variant_title);
        // for (const image of filtered_media) {
        //         if(filtered_media.length > 1){
        //             $(".Product__Media__Sidebar__carousel").append(`
        //                 <div class="Product__Media__Sidebar__item__wrapper" data-slick-index="${id}">
        //                     <img
        //                         class="Product__Media__Sidebar__item"
        //                         data-id="${id}"
        //                         src="${image[1]}"
        //                         alt="${variant_title}">
        //                 </div>
        //             `);
        //         } else {
        //             $(".Product__Media__Sidebar").addClass("hidden");
        //             $(".Product__Media__Main").addClass("full");
        //         }
        //         $(".Product__Media__Main__carousel").append(`
        //             <div class="Product__Media__Main__item__wrapper" data-slick-index="${id}">
        //                 <img
        //                     class="Product__Media__Main__item"
        //                     data-id="${id}"
        //                     src="${image[2]}"
        //                     alt="${variant_title}">
        //             </div>  
        //         `);
        //         id++;
        //     }

        //     initCarousels(filtered_media.length);
        // }

        const initCarousels = (slides) => {
            if(slides > 4){

                $(".Product__Media__Sidebar__carousel").on("init", function(){
                    $(".Product__Media__Sidebar__item__wrapper[data-slick-index=0]").addClass("Sidebar__item__active");
                    $(window).trigger("resize");
                });
    
                $(".Product__Media__Sidebar__carousel:not(.hidden)").slick({
                    vertical: true,
                    verticalSwiping: true,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    prevArrow: arrowUpHtml,
                    nextArrow: arrowDownHtml,
                    infinite: false,
                    useTransform: false
                });
            } else {
                $(".Product__Media__Sidebar__item__wrapper:first-child").addClass("Sidebar__item__active");
                $(".Product__Media__Sidebar__carousel").addClass("no-carousel");
            }

            let sliderInitialized = false;
            if(slides > 1){
                $(".Product__Media__Main__carousel").on("afterChange", function(){
                    const id = $(".Product__Media__Main__item__wrapper.slick-current").attr("data-slick-index");
                    if($(".Product__Media__Sidebar__carousel").hasClass("slick-slider")){
                        $(".Product__Media__Sidebar__carousel").slick("slickGoTo", id);
                        $(".Product__Media__Sidebar__carousel").slick("setPosition");
                    }
                    $(".Product__Media__Sidebar__item__wrapper").removeClass("Sidebar__item__active");
                    $(`.Product__Media__Sidebar__item__wrapper[data-slick-index=${id}]`).addClass("Sidebar__item__active");
                });

                $(".Product__Media__Main__carousel").on("init", function(){
                    sliderInitialized = true;
                });

                $(".Product__Media__Main__carousel:not(.not-carousel)").slick({
                    arrows: false,
                    dots: true,
                    appendDots: $(".Product__Media__Main__dots"),
                    adaptiveHeight: true,
                    useTransform: false
                });
            } else {
                if($(".Product__Media__Main__carousel.not-carousel").length){
                    sliderInitialized = true;
                }
            }

            function allImagesLoaded() {
                // get all images on the page
                var images = document.getElementsByTagName('img');
              
                for (var i = 0; i < images.length; i++) {
                  // if any of the images are still loading, return false
                  if (!images[i].complete) {
                    return false;
                  }
                }
              
                // all images have finished loading
                return true;
              }
              
              // call this function after the page has finished loading
              window.onload = function() {
                // wait for all images to finish loading
                var checkImages = setInterval(function() {
                  if (allImagesLoaded()) {
                    clearInterval(checkImages);
                    if(toSlide){
                        $(".Product__Media__Sidebar__carousel").slick("slickGoTo", parseInt(toSlide), true);
                        $(".Product__Media__Main__carousel").slick("slickGoTo", parseInt(toSlide), true);
                    }
                    // execute some code once all images have loaded
                    $(".Product__Media.spinning").removeClass("spinning");
                  }
                }, 100);
              };
              
        }

        const destroyCarousels = () => {
            if($(".Product__Media__Sidebar__carousel").hasClass("slick-slider")){
                $(".Product__Media__Sidebar__carousel").slick('unslick');
            }
            if($(".Product__Media__Main__carousel").hasClass("slick-slider")){
                $(".Product__Media__Main__carousel").slick('unslick');
            }
            $(".Product__Media__Sidebar").html(`
                <div class="Product__Media__Sidebar__carousel"></div>
            `);
            $(".Product__Media__Main").html(`
                <div class="Product__Media__Main__carousel"></div>
                <div class="Product__Media__Main__dots"></div>
            `);
        }

        // Image carousel code
        const arrowUpHtml = `<svg width="26" class="carousel-arrow-up" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="13" cy="13" r="12.6" transform="rotate(90 13 13)" stroke="#2C2F7E" stroke-width="0.8"/>
        <path d="M16.3475 13.1738L15.9073 13.5908L13.1737 10.8804L10.4402 13.5908L10 13.1738L13.1737 10.0001L16.3475 13.1738Z" fill="#2C2F7E"/>
        <path d="M13.498 10.4402L13.498 16L12.8494 16L12.8494 10.4402L13.498 10.4402Z" fill="#2C2F7E"/>
        </svg>`;
        const arrowDownHtml = `<svg width="26" class="carousel-arrow-down" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="13" cy="13" r="12.6" transform="rotate(-90 13 13)" fill="white" stroke="#2C2F7E" stroke-width="0.8"/>
        <path d="M10.3999 13.4561L10.7602 13.1147L12.9977 15.3333L15.2352 13.1147L15.5955 13.4561L12.9977 16.0538L10.3999 13.4561Z" fill="#2C2F7E"/>
        <path d="M12.7324 15.6937L12.7324 11.1428L13.2633 11.1428L13.2633 15.6937L12.7324 15.6937Z" fill="#2C2F7E"/>
        </svg>`;

        initCarousels($(".Product__Media__Sidebar__item__wrapper").length);

        $(document).on("click", ".Product__Media__Sidebar__item__wrapper", function(e){
            $(".Product__Media__Sidebar__item__wrapper").removeClass("Sidebar__item__active");
            $(this).addClass("Sidebar__item__active");
            const id = $(this).attr("data-slick-index");
            $(".Product__Media__Main__carousel").slick("slickGoTo", parseInt(id));
        });

        $(document).on("click", function(){
            if($(".ProductForm__Custom__Swatches__wrapper").hasClass("opened")){
                $(".ProductForm__Custom__Swatches__wrapper").removeClass("opened");
                $(".ProductForm__Custom__Swatches").slideUp(200);
            }
        });

        // Swatches code
        $(".ProductForm__Custom__Swatches__selected").on("click", function(e){
            e.stopPropagation();
            $(".ProductForm__Custom__Swatches__wrapper").toggleClass("opened");
            $(".ProductForm__Custom__Swatches").slideToggle(200);
        });
        $(".ProductForm__Custom__Swatch").on("click", function(e){
            e.stopPropagation();
            if(!$(this).hasClass("ProductForm__Custom__Swatch__active")){
                $(".ProductForm__Custom__Swatch.ProductForm__Custom__Swatch__active").removeClass("ProductForm__Custom__Swatch__active");
                $(this).addClass("ProductForm__Custom__Swatch__active");
                const variant_id = $(this).attr("data-variant");
                const variant_title = $(this).attr("data-variant-title");
                const variant_price = $(this).attr("data-variant-price");
                const url = window.location.href.split("?")[0]+"?variant="+variant_id;
                window.history.pushState({path:url},'',url);
                // destroyCarousels();
                // fillImages(variant_title);
                const slick_id = $(`.Product__Media__Main__item[data-src="${$(this).attr("data-variant-src")}"]`).parent().attr("data-slick-index");
                $(".Product__Media__Sidebar__carousel").slick("slickGoTo", slick_id, true);
                $(".Product__Media__Main__carousel").slick("slickGoTo", slick_id, true);
                // $(`.Product__Media__Main__item[alt="${$(this).text()}"]`);

                $(".ProductMeta__Price").text(Currency.formatMoney(variant_price, theme.moneyFormat));

                $(".ProductForm__Option select").val(variant_id);
                $(".ProductMeta__UnitPriceMeasurement").hide();
                $(`.ProductMeta__UnitPriceMeasurement-${variant_id}`).hasClass("can-be-shown") ? $(`.ProductMeta__UnitPriceMeasurement-${variant_id}`).show() : null;
            
                $(".ProductForm__Custom__Swatches__wrapper").removeClass("opened");
                $(".ProductForm__Custom__Swatches").slideUp(200);

                $(".ProductForm__Custom__Swatches__variant").text(variant_title);

                if($(this).hasClass("unavailable")){
                    $(".Button.unavailable").addClass("shown");
                    $(".Button.available").removeClass("shown");
                } else {
                    $(".Button.unavailable").removeClass("shown");
                    $(".Button.available").addClass("shown");
                }
            }
        });

        // READ MORE
        $(".read-more-btn").on("click", function(){
            $(".ProductReadMore__First").toggleClass("revealed");
            $(this).toggleClass("active");
        });

        // Scroll bar
        const height_of_description = $(".Product__InfoWrapper").outerHeight(true);
        const height_of_image = $(".Product__Media__Main__carousel").outerHeight(true);
        $(".Product__InfoWrapper").css("max-height", `${height_of_description < height_of_image ? height_of_image : height_of_description}px`);
        new SimpleBar($('.Product__InfoWrapper')[0], {
            autoHide: false
        });
        $(".imageswatch-slider-header").on("click", function(){
            $(this).toggleClass("shown")
            $(this).next().slideToggle(200);
        })
    });


});